// Where section (Copybara · Vibe Invest merged)
import { Eyebrow, Icon } from "./Pieces";
import { PROJECTS } from "../data";

function CopybaraPreview() {
  return (
    <a
      className="cb-thumb"
      href="https://copybara-pi.vercel.app/"
      target="_blank"
      rel="noreferrer"
      aria-label="Open Copybara prototype"
    >
      <div className="cb-thumb-chrome">
        <span className="traffic">
          <i />
          <i />
          <i />
        </span>
        <span className="cb-thumb-url">
          <Icon name="lock" size={11} style={{ marginRight: 6, verticalAlign: "-1px" }} />
          copybara-pi.vercel.app
        </span>
        <span className="cb-thumb-open">
          <Icon name="north_east" size={14} />
        </span>
      </div>
      <div className="cb-thumb-body">
        <div className="cb-thumb-hero">
          <div className="cb-thumb-eyebrow">VIBE INVEST · PROTOTYPE</div>
          <div className="cb-thumb-title">
            자연어로 만드는<br />나만의 투자전략
          </div>
          <div className="cb-thumb-search">
            <Icon name="chat" size={14} style={{ opacity: 0.6 }} />
            <span>"배당주 위주, 변동성 낮게, 월 50만원 적립"</span>
            <span className="cb-thumb-go">↑</span>
          </div>
        </div>
        <div className="cb-thumb-grid">
          <div className="cb-thumb-tile t-a">
            <div className="tt-label">아침 매거진</div>
            <div className="tt-bars">
              <i style={{ height: "40%" }} />
              <i style={{ height: "70%" }} />
              <i style={{ height: "55%" }} />
              <i style={{ height: "85%" }} />
            </div>
          </div>
          <div className="cb-thumb-tile t-b">
            <div className="tt-label">클랜</div>
            <div className="tt-clan">
              <span className="tt-avatar" style={{ background: "#ED8B5A" }} />
              <span className="tt-avatar" style={{ background: "#4ECDC4" }} />
              <span className="tt-avatar" style={{ background: "#5B9BD5" }} />
              <span className="tt-avatar ghost">+</span>
            </div>
          </div>
          <div className="cb-thumb-tile t-c">
            <div className="tt-label">페르소나</div>
            <div className="tt-persona">
              안정 적립형<br />사냥꾼
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}

function VibePreview() {
  return (
    <div className="vibe-preview">
      <div className="vp-prompt">
        <span className="vp-pr-label">prompt</span>
        <span className="vp-pr-text">
          매달 첫째 주 월요일, KODEX 200을 10만원씩 사고, 50일 이평선 아래면 30%만.
        </span>
      </div>
      <div className="vp-blocks">
        <div className="vp-block">
          <span className="type-eyebrow">Trigger</span>
          <span>월 1회 · 1st Mon</span>
        </div>
        <div className="vp-block">
          <span className="type-eyebrow">Asset</span>
          <span>KODEX 200 · 069500</span>
        </div>
        <div className="vp-block">
          <span className="type-eyebrow">Rule</span>
          <span>SMA(50) guard</span>
        </div>
      </div>
      <div className="vp-chart">
        <svg viewBox="0 0 200 70" preserveAspectRatio="none">
          <defs>
            <linearGradient id="vgrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ED8B5A" stopOpacity="0.45" />
              <stop offset="100%" stopColor="#ED8B5A" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path
            d="M0,55 L20,50 L40,54 L60,42 L80,44 L100,36 L120,32 L140,26 L160,28 L180,18 L200,14 L200,70 L0,70 Z"
            fill="url(#vgrad)"
          />
          <path
            d="M0,55 L20,50 L40,54 L60,42 L80,44 L100,36 L120,32 L140,26 L160,28 L180,18 L200,14"
            stroke="#ED8B5A"
            strokeWidth="1.4"
            fill="none"
          />
          <path
            d="M0,60 L200,30"
            stroke="#8E8E8E"
            strokeWidth="0.7"
            strokeDasharray="2,2"
            fill="none"
          />
        </svg>
        <div className="vp-stat-row">
          <div>
            <span className="type-eyebrow">5Y CAGR</span>
            <span className="mono pos">+9.4%</span>
          </div>
          <div>
            <span className="type-eyebrow">MDD</span>
            <span className="mono neg">−18.7%</span>
          </div>
          <div>
            <span className="type-eyebrow">Sharpe</span>
            <span className="mono">0.72</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function WhereSection() {
  const copybara = PROJECTS[0];
  const vibe = PROJECTS[1];
  return (
    <section className="section" id="where">
      <div className="section-head">
        <Eyebrow accent="main">어디로 가는가 · Where we're going</Eyebrow>
        <h2 className="section-title">자연어 투자 알고리즘</h2>
        <p className="section-lede">
          재미있고 쉬운 투자 커뮤니티 · 투자전략 생성 서비스. 퀀트 투자자들의 핵심 커뮤니티를 지향합니다.
        </p>
      </div>

      <div className="copybara-card">
        <div className="copybara-left">
          <div className="copybara-badge">
            <span className="status-dot" style={{ background: "var(--aipq-point1)" }} />
            {copybara.status}
          </div>
          <h3 className="copybara-name">Vibe Invest</h3>
          <p className="copybara-tagline">{copybara.tagline}</p>
          <p className="copybara-oneliner">{copybara.oneLiner}</p>
          <ul className="bullet-list">
            {copybara.bullets.map((b) => (
              <li key={b}>
                <span className="bullet">—</span>
                {b}
              </li>
            ))}
          </ul>
        </div>
        <div className="copybara-right">
          <CopybaraPreview />
        </div>
      </div>

      <div className="vibe-card" style={{ marginTop: 32 }}>
        <div className="vibe-left">
          <div className="copybara-badge">
            <span className="status-dot" style={{ background: "var(--aipq-main)" }} />
            {vibe.status}
          </div>
          <h3 className="copybara-name">한 줄 → 전략 → 백테스트</h3>
          <p className="copybara-tagline">{vibe.tagline}</p>
          <ul className="bullet-list">
            {vibe.bullets.map((b) => (
              <li key={b}>
                <span className="bullet">—</span>
                {b}
              </li>
            ))}
          </ul>
        </div>
        <div className="vibe-right">
          <VibePreview />
        </div>
      </div>
    </section>
  );
}
